import { inject, Service } from '@angular/core';
import { OnOpenAboutDialog } from '@portal-core/layout/services/layout-event-handler.interface';
import { MatDialog } from '@angular/material/dialog';
import { AppAboutDialogComponent } from '@portal-client/app/components/app-about-dialog/app-about-dialog.component';

@Service()
export class LayoutEventHandlerService implements OnOpenAboutDialog {
  private readonly dialog = inject(MatDialog);

  onOpenAboutDialog() {
    this.dialog.open(AppAboutDialogComponent, {
      width: '52rem',
      panelClass: 'mc-dialog-card-container'
    });
  }
}
